import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;

  & > *:not(:last-child) {
    margin-left: ${globalTheme.spacing.sm};
  }
`;
